module.exports = __webpack_public_path__ + "img/Picture16.daed2de8.png";